import "./Footer.css";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <div className="flex min-h-[5vh] flex-col items-center justify-between bg-rld-black">
      <div className="bg-rld-border h-px w-full"></div>
      <div className="min-h-[4.5vh] flex flex-col justify-center items-center">
        <p className="pb-2 font-light text-sm text-rld-muted md:text-base">
          © {currentYear} Rare Life Design
        </p>
      </div>
    </div>
  );
}

export default Footer;
